import { userConstants } from '../../components';

export function usersData(state = {}, action) {
    switch (action.type) {
        case userConstants.GETALL_REQUEST:
            return {
                loading: true,
            };
        case userConstants.GETALL_SUCCESS:
            return {
                rows: action.data.list,
                pageIndex: action.data.pageIndex,
                pageSize: action.data.pageSize,
                totalCount: action.data.totalCount,
                totalPages: action.data.totalPages,
            };
        case userConstants.GETALL_FAILURE:
            return {
                error: action.error,
            };
        case userConstants.DELETE_REQUEST:
            // add 'deleting:true' property to user being deleted
            return {
                ...state,
                items: state.items.map(user =>
                    user.id === action.id ? { ...user, deleting: true } : user,
                ),
            };
        case userConstants.DELETE_SUCCESS:
            // remove deleted user from state
            return {
                items: state.items.filter(user => user.id !== action.id),
            };
        case userConstants.DELETE_FAILURE:
            // remove 'deleting:true' property and add 'deleteError:[error]' property to user
            return {
                ...state,
                items: state.items.map(user => {
                    if (user.id === action.id) {
                        // make copy of user without 'deleting:true' property
                        const { deleting, ...userCopy } = user;
                        // return copy of user with 'deleteError:[error]' property
                        return { ...userCopy, deleteError: action.error };
                    }

                    return user;
                }),
            };
        default:
            return state;
    }
}

export function usersFilters(state = {}, action) {
    switch (action.type) {
        case userConstants.GETALL_FILTERS_REQUEST:
            return {
                loading: true,
            };
        case userConstants.GETALL_FILTERS_SUCCESS:
            return {
                usersFilters: action.usersFilters,
            };
        case userConstants.GETALL_FILTERS_FAILURE:
            return {
                error: action.error,
            };
        default:
            return state;
    }
}
// export function userIsEmailUnique(state = {}, action) {
//     switch (action.type) {
//         case userConstants.ISEMAILUNIQUE_REQUEST:
//             return {
//                 loading: true,
//             };
//         case userConstants.ISEMAILUNIQUE_SUCCESS:
//             return {
//                 response: action,
//             };
//         case userConstants.ISEMAILUNIQUE_FAILURE:
//             return {
//                 error: action.error,
//             };
//         default:
//             return state;
//     }
// }
